import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    class: "sidebar offcanvas offcanvas-start",
    tabindex: "-1",
    id: "sidebar",
    "aria-labelledby": "sidebarLabel"
};
var _hoisted_2 = { class: "offcanvas-body" };
var _hoisted_3 = { class: "d-flex justify-content-end" };
var _hoisted_4 = { id: "sidebar_menu" };
var _hoisted_5 = { key: 0 };
var _hoisted_6 = { key: 1 };
var _hoisted_7 = { key: 2 };
var _hoisted_8 = {
    class: "accordion",
    id: "platformsModule"
};
var _hoisted_9 = { class: "accordion-item" };
var _hoisted_10 = {
    id: "platforms",
    class: "accordion-collapse collapse",
    "data-bs-parent": "#platformsModule"
};
import { useAuthStore } from '@/stores/authStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SideBar',
    setup: function (__props) {
        var auth = useAuthStore();
        return function (_ctx, _cache) {
            var _a, _b, _c;
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_font_awesome_icon, {
                            class: "close-icon",
                            icon: ['far', 'circle-xmark'],
                            size: "2x",
                            "data-bs-dismiss": "offcanvas",
                            "aria-label": "Close"
                        })
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "logo d-flex justify-content-between" }, [
                        _createElementVNode("a", {
                            class: "large_logo",
                            href: "index.html"
                        }, [
                            _createElementVNode("img", {
                                class: "img-fluid",
                                src: "/logo.png",
                                alt: ""
                            })
                        ])
                    ], -1)),
                    _createElementVNode("ul", _hoisted_4, [
                        _createElementVNode("li", null, [
                            _createVNode(_component_router_link, { to: "/" }, {
                                default: _withCtx(function () { return _cache[0] || (_cache[0] = [
                                    _createTextVNode("Inicio")
                                ]); }),
                                _: 1
                            })
                        ]),
                        _createElementVNode("li", null, [
                            _createVNode(_component_router_link, { to: "/dashboard" }, {
                                default: _withCtx(function () { return _cache[1] || (_cache[1] = [
                                    _createTextVNode("Dashboard")
                                ]); }),
                                _: 1
                            })
                        ]),
                        (((_a = _unref(auth).user) === null || _a === void 0 ? void 0 : _a.role) === 'Administrador')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                _createVNode(_component_router_link, { to: "/admin/users" }, {
                                    default: _withCtx(function () { return _cache[2] || (_cache[2] = [
                                        _createTextVNode("Usuarios")
                                    ]); }),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true),
                        (((_b = _unref(auth).user) === null || _b === void 0 ? void 0 : _b.role) === 'Administrador')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                _createVNode(_component_router_link, { to: "/admin/clients" }, {
                                    default: _withCtx(function () { return _cache[3] || (_cache[3] = [
                                        _createTextVNode("Clientes")
                                    ]); }),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true),
                        (((_c = _unref(auth).user) === null || _c === void 0 ? void 0 : _c.role) === 'Administrador')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "accordion-header" }, [
                                            _createElementVNode("div", {
                                                class: "accordion-button collapsed",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": "#platforms",
                                                "aria-expanded": "false",
                                                "aria-controls": "platforms"
                                            }, " Plataformas ")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("ul", null, [
                                                _createElementVNode("li", null, [
                                                    _createVNode(_component_router_link, { to: "/admin/platforms" }, {
                                                        default: _withCtx(function () { return _cache[4] || (_cache[4] = [
                                                            _createElementVNode("span", null, null, -1),
                                                            _createElementVNode("span", null, "Plataformas", -1)
                                                        ]); }),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createVNode(_component_router_link, { to: "/admin/groups" }, {
                                                        default: _withCtx(function () { return _cache[5] || (_cache[5] = [
                                                            _createElementVNode("span", null, null, -1),
                                                            _createElementVNode("span", null, "Grupos o cuentas", -1)
                                                        ]); }),
                                                        _: 1
                                                    })
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
